<template>
  <div class="page">
    <!-- header -->
    <xh-header />

    <!-- banner -->
    <ny-banner v-if="banner.length" :banner="banner[0]" />

    <!-- 面包屑 -->
    <div class="crumbs">
      <div>会员专区 > 注册/登陆</div>
    </div>

    <div class="container-width">
      <div class="form">
        <h3>登陆</h3>
        <el-form ref="formLogin" :model="loginForm" :rules="loginRules">
          <el-form-item prop="phone">
            <el-input v-model="loginForm.phone" placeholder="手机号码" />
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" v-model="loginForm.password" placeholder="密码" />
          </el-form-item>
          <div class="btn primary" @click="loginHandler" style="margin-top: 32px;">登陆</div>
          <div class="form-bottom">
            <span class="fl mouse" @click="$router.push('/login/register')">立即注册</span>
            <span class="fr mouse color1" @click="$router.push('/login/forget-password')">忘记密码？</span>
          </div>
        </el-form>
      </div>
    </div>

    <!-- footer -->
    <xh-footer />
  </div>
</template>
<script>
import XhHeader from '../../reveals/xh-header.vue'
import XhFooter from '../../reveals/xh-footer.vue'
import NyBanner from '../../sections/ny-banner.vue'
import { checkPhone } from '@/utils/util'
import { login } from '@/service/apis/userinfo'
import { getBanner } from '@/service/apis/common'

const isPhone = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('手机号码不能为空'))
  } else if (!checkPhone(value)) {
    callback(new Error('请输入正确的手机号码'))
  } else {
    callback()
  }
};
export default {
  components: {
    XhHeader,
    XhFooter,
    NyBanner
  },
  name: 'Login',
  data () {
    return {
      banner: [],
      loginForm: {
        phone: '',
        password: ''
      },
      loginRules: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: isPhone, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    getBanner(this).then(data => {
      // 会员专区banner 11
      if (data[11]) {
        this.banner = [...data[11]]
      }
    })
  },
  methods: {
    // 登录
    loginHandler () {
      this.$refs['formLogin'].validate((valid) => {
        if (valid) {
          let opt = {
            ...this.loginForm,
            sourceType: 1 // pc
          }

          login.call(this, opt).then(resp => {
            if (resp.errCode === 0) {
              localStorage.setItem('TOKEN', resp.data.token)
              localStorage.setItem('ACCOUNT', JSON.stringify(resp.data.accountDto))
              this.$router.replace('/userinfo')
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.form {
  padding: 22px 0;
  max-width: 490px;
}
.form h3 {
  font-size: 18px;
  line-height: 44px;
}
.btn {
  color: #fff;
  margin-top: 14px;
  height: 38px;
  line-height: 38px;
  cursor: pointer;
  text-align: center;
  background-color: #846edc;
}
.btn.primary {
  background-color: #4c2ac9;
}
::v-deep .el-form-item {
  margin-bottom: 18px;
}
.send-txt {
  float: left;
  width: calc(100% - 32.6% - 8px);
}
.send-btn {
  margin-top: 0;
  float: right;
  display: block;
  width: 32.6%;
}
.btn-disable {
  opacity: 0.6;
  cursor: not-allowed;
}
.form-bottom {
  color: #666;
  padding: 12px 0 48px 0;
  line-height: 22px;
}
.color1 {
  color: #4c2ac9;
}
.form-bottom span:hover {
  color: #4c2ac9;
}
</style>
